module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/pins/silver-337e6717502388a0af070522e6ee2809.svg";